import { listData } from '../../../../common/data'
import Pagination from '../../../../Components/Common/Pagination'
import React, {useEffect, useMemo, useState} from 'react'
import { Link, useSearchParams  } from 'react-router-dom'
import { Card, CardBody, Col, Row } from 'reactstrap'
import ApiService from "../../util/ApiService";
import CustomPagination from "../../util/CustomPagination";
import Skeleton from "react-loading-skeleton";
import GuideEditModal from "./GuideEditModal";
import AuthService from "../../login/AuthService";

const MainList = () => {
    const userData = AuthService.getUserData();
    const [searchParams] = useSearchParams();
    const categoryId = searchParams.get('category');
    const description = searchParams.get('description');
    const [guides, setGuides] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 3, total: 0, lastPage: 0 });
    const [loading, setLoading] = useState(true);


    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedGuide, setSelectedGuide] = useState(null);

    useEffect(() => {
        fetch();
    }, []);


    const fetch = async (page) => {
        try {
            setLoading(true);
            const response = await ApiService.send('post', process.env.REACT_APP_URL_API + 'guide-user/list',
                {
                    page:page,
                    per_page:pagination.pageSize,
                    guide_user_category_id: categoryId,
                    description: description
                }, true
            );

            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setPagination(pagInfo || {current: 1, pageSize: 3, total: 0});
            setGuides(data);

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (page) => {
        fetch(page);
    };

    const stripHtml = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };


    const openEditModal = (item) => {
        setSelectedGuide(item);
        setShowEditModal(true);
    };

    const closeEditModal = () => {
        setShowEditModal(false);
        setSelectedGuide(null);
    };

    return (
        <React.Fragment>
            <div className="col-xxl-9">

                {userData?.admin === true && (
                    <button className="btn btn-sm btn-success mb-2"  onClick={() => openEditModal(null)}><i className="fa fa-plus"></i>  Cadastrar</button>
                )}

                <Row className='gx-4'>
                    {loading ? (
                        [...Array(3)].map((_, i) => (
                            <Col xxl={12} key={i}>
                                <Skeleton height={120} />
                            </Col>
                        ))
                    ) : (guides.map((item, idx) => (
                        <Col xxl={12} key={idx}>
                            <Card>
                                <CardBody>
                                    <div className="row g-4">
                                        <div className="col-xxl-3 col-lg-5">
                                          <a  href={`/admin/user-guide-description/${item.url}`}>  <img
                                                src={item.image_url || 'https://via.placeholder.com/400x250?text=Sem+Imagem'}
                                                alt={item.title}
                                                className="img-fluid rounded w-100 object-fit-cover"
                                                style={{ height: '130px', objectFit: 'cover' }}
                                            />
                                          </a>
                                        </div>
                                        <div className="col-xxl-9 col-lg-7">
                                            <p className="mb-2 text-primary text-uppercase">
                                                {item.category?.name || 'Sem categoria'}
                                            </p>
                                            <a href={`/admin/user-guide-description/${item.url}`}>
                                                <h5 className="fs-15 fw-semibold">{item.title}</h5>
                                            </a>
                                            {/* Dados adicionais omitidos por enquanto */}
                                            <p className="text-muted mb-2">
                                                {stripHtml(item.description).slice(0, 150)}...
                                            </p>
                                            {userData?.admin === true && (
                                            <button
                                                type="button"
                                                className="me-2 btn btn-sm btn-success"
                                                onClick={() => openEditModal(item)}
                                            >
                                                <i className="fa fa-edit"></i> Editar
                                            </button>
                                            )}
                                            <a href={`/admin/user-guide-description/${item.url}`}
                                               className="text-decoration-underline me-2">
                                                Leia mais <i className="ri-arrow-right-line"></i>
                                            </a>


                                            {/* Se você tiver tags futuramente */}
                                            {item?.tags && (
                                                <div className="d-flex align-items-center gap-2 mt-3 flex-wrap">
                                                    {item.tags.map((tag, idx) => (
                                                        <Link to="#!" key={idx}
                                                              className="badge text-success bg-success-subtle">
                                                            {tag}
                                                        </Link>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        ))
                    )}
                </Row>

                <div className="row g-0 text-center text-sm-start align-items-center mb-4">
                    <div className="col-sm-6">
                        <CustomPagination
                            pagination={pagination}
                            onChange={handlePageChange}
                        />
                    </div>
                </div>
            </div>

            <GuideEditModal show={showEditModal}  onHide={closeEditModal} guide={selectedGuide}/>
        </React.Fragment>
    )
}

export default MainList